import { render, staticRenderFns } from "./FaqCardPost.vue?vue&type=template&id=675a3d0c&scoped=true"
import script from "./FaqCardPost.vue?vue&type=script&lang=js"
export * from "./FaqCardPost.vue?vue&type=script&lang=js"
import style0 from "./FaqCardPost.vue?vue&type=style&index=0&id=675a3d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a3d0c",
  null
  
)

export default component.exports